<section class="personal-identity">
  <div class="personal-identity__name-wrapper">
    <h1 *ngIf="profile?.lastName" class="personal-identity__name">
      <span itemprop="givenName">{{ profile?.firstName }} </span>
      <span itemprop="familyName">{{ profile?.lastName }}</span>
    </h1>

    <app-svg-icon class="personal-identity__icon" icon="bee" width="1.625em"></app-svg-icon>
  </div>

  <h2 *ngIf="profile?.title" class="personal-identity__work" itemprop="jobTitle">{{ profile?.title }}</h2>

  <p *ngIf="age && profile?.location && profile?.location.city" class="personal-identity__age-and-location" i18n>
    {{ age }} ans &bull; {{ profile?.location.city }}
  </p>
</section>
